export const privacyPolicy = (
  <div className="policy-document">
    <section className="policy-intro">
      <h3>Privacy Policy for AroundU</h3>
      <p>Last updated: {new Date().toLocaleDateString()}</p>
      <p>Welcome to AroundU. Your privacy is important to us.</p>
    </section>

    <section>
      <h4>1. Information We Collect</h4>
      <p>We collect information that you provide directly to us, including:</p>
      <ul>
        <li>Name, email address, and contact information</li>
        <li>Business details and service information</li>
        <li>Location data and service area information</li>
        <li>User account credentials and preferences</li>
        <li>Payment information (processed securely through our payment providers)</li>
      </ul>
    </section>

    <section>
      <h4>2. How We Use Your Information</h4>
      <p>We use the collected information to:</p>
      <ul>
        <li>Provide and maintain our services</li>
        <li>Connect service providers with potential clients</li>
        <li>Process transactions and send related information</li>
        <li>Improve and personalize user experience</li>
        <li>Send important updates and notifications</li>
        <li>Prevent fraud and enhance security</li>
      </ul>
    </section>

    <section>
      <h4>3. Information Sharing</h4>
      <p>We may share your information with:</p>
      <ul>
        <li>Service providers and business partners</li>
        <li>Other users as needed to facilitate services</li>
        <li>Law enforcement when required by law</li>
      </ul>
    </section>

    <section>
      <h4>4. Data Security</h4>
      <p>We implement appropriate security measures to protect your personal information, including:</p>
      <ul>
        <li>Encryption of sensitive data</li>
        <li>Regular security assessments</li>
        <li>Secure data storage practices</li>
        <li>Partnership with Watchdogs Cyber Security</li>
      </ul>
    </section>

    <section>
      <h4>5. Your Rights</h4>
      <p>You have the right to:</p>
      <ul>
        <li>Access your personal information</li>
        <li>Correct inaccurate data</li>
        <li>Request deletion of your data</li>
        <li>Opt-out of marketing communications</li>
        <li>Lodge a complaint with supervisory authorities</li>
      </ul>
    </section>
  </div>
); 